import type { RecoverPasswordRoute } from "@/app/api/auth/recover-password/route";
import { postJson } from "@/utils/routeUtils";
import { mutationOptions } from "@tanstack/react-query";

type RecoverPasswordInput = RecoverPasswordRoute["input"];

export const recoverPasswordMutationOptions = ({
  getTurnstileToken,
}: {
  getTurnstileToken: () => Promise<string | undefined>;
}) =>
  mutationOptions({
    mutationFn: async ({
      newPassword,
    }: Pick<RecoverPasswordInput, "newPassword">) => {
      const captchaToken = await getTurnstileToken();
      if (!captchaToken) {
        throw new Error(
          "Security verification failed. Please refresh and try again."
        );
      }

      const result = await postJson(
        "/api/auth/recover-password",
        { newPassword, captchaToken },
        { skipLogs: true }
      );

      if (!result.success) {
        throw new Error(result.error ?? "Failed to recover password");
      }

      return result.data;
    },
  });
